<!--  -->
<template>
  <div>
    <div class="myHeader" style="background: linear-gradient(90.1deg, rgb(212 184 233) 0.1%, rgb(117 41 181) 100%)">
        <div class="my_1">
            <img src="/static/images_m/5.jpg" class="tx">
            <span>{{this.user.name}}</span>
        </div>
        <div class="my_2">
            <a  href="#" @click="loginOut()" class="L">个人信息</a>
            <a  @click="loginOut()" class="R">退出登录</a>
        </div>
       
    </div>
     <div class="mybox_2">
        <ul>
            <li><p>1天</p><span>坚持天数</span></li>
            <li><p>3章</p><span>学习章节</span></li>
            <li><p>80%</p><span>练习正确率</span></li>
        </ul>
     </div>
     <div class="clear"></div>
        <div class="mybox_3">
            <ul>
                <li><router-link to="/mistakelist"><img src="/static/images_m/cuotiben_a.svg"><p>错题本</p></router-link></li>
                <li><router-link to="/examrecord"><img src="/static/images_m/jilu_a.svg"><p>考试记录</p></router-link></li>
                <li><a href="#" @click="visibleChgPwd=true;"><img src="/static/images_m/gaimi_a.svg" ><p>修改密码</p></a></li>
            </ul>
        </div>
    <el-dialog
        title="输入新密码"
        :visible.sync="visibleChgPwd"
        width="95%"
        center>
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="68px" class="demo-ruleForm">
            <el-form-item label="原密码" prop="currentPassword">
                <el-input  type="password" v-model="ruleForm.currentPassword"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="newPassword">
                <el-input type="password" v-model="ruleForm.newPassword" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPass">
                <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item style="text-align:center">
                <el-button type="primary" @click="chgPassword('ruleForm')">确认修改</el-button>
            </el-form-item>
        </el-form>
        </el-dialog>
  </div>
</template>

<script>
import {Message} from "element-ui";
export default {
  data () {
    var checkAge = (rule, value, callback) => {
        if (!value) {
            return callback(new Error('请输入原密码'));
        }else{
            callback();
        }
    };
    var validatePass = (rule, value, callback) => {
        if (value === '') {
            callback(new Error('请输入新密码'));
        } else {
            if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
            }
            callback();
        }
    };
    var validatePass2 = (rule, value, callback) => {
    if (value === '') {
        callback(new Error('请再次输入密码'));
    } else if (value !== this.ruleForm.newPassword) {
        callback(new Error('两次输入密码不一致!'));
    } else {
        callback();
    }
    };
    return {
        user:{
           
        },
         visibleChgPwd:false,
        ruleForm: {
          newPassword: '',
          checkPass: '',
          currentPassword: ''
        },
        rules: {
          newPassword: [
            { validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
            { validator: validatePass2, trigger: 'blur' }
          ],
          password: [
            { validator: checkAge, trigger: 'blur' }
          ]
        }
    };
  },

  components: {},

  computed: {},

  mounted(){
      this.$axios.get("/api/auth/me").then(res => {
          this.user = res.data.data;
        })
  },

  methods: {
      updateInfo(){
          this.$axios.put("/api/auth/updatedetails", this.user).then(res => {
                if(res.data){
                    Message.success("更新成功");
                }
          })
      },
      chgPassword(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            //alert('submit!');
            this.$axios.put("/api/auth/updatePassword", this.ruleForm).then(res => {
                if(res.data){
                    Message.success("更新成功");
                }
                this.visibleChgPwd = false;
            })
          } else {
            //console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      loginOut(){
           localStorage.removeItem("eleTokenCustCysd001");
            this.$store.dispatch("clearCurrentState");
            // 页面跳转
            this.$router.push("/login");
      }
  }
}

</script>
<style lang="scss" scoped>
@import "@/assets/css/style_Phone.scss";
</style>